export default function loadLang(lang = 'fr') {
    return require(`./${lang.toLowerCase()}.i18n.json`);
}
